import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FIRST_NAME_VALIDATION } from "@app/shared/constants/settings.constant";
import { NgModel, FormsModule } from "@angular/forms";
import { FirstNameModel } from "@app/shared/components/first-name/first-name.model";
import { TitleCasePipe, NgIf } from "@angular/common";
import { ValidationMessagesComponent } from "../validation/validation-messages.component";
import { CustomAutoFocusDirective } from "../../directives/auto-focus/auto-focus";
import { APatternRestrict } from "../../directives/a-pattern-restrict/a-pattern-restrict";
import { MatInput } from "@angular/material/input";
import { GtmChangeDirective } from "../../directives/gtm-form-event/gtm-change.directive";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { ProvideParentFormDirective } from "../../directives/provide-parent-form/provide-parent-form.directive";

@Component({
  selector: "app-first-name",
  templateUrl: "./first-name.component.html",
  providers: [TitleCasePipe],
  standalone: true,
  imports: [
    ProvideParentFormDirective,
    MatFormField,
    MatLabel,
    NgIf,
    GtmChangeDirective,
    MatInput,
    FormsModule,
    APatternRestrict,
    CustomAutoFocusDirective,
    MatError,
    ValidationMessagesComponent,
    TitleCasePipe
  ]
})
export class FirstNameComponent {
  @Input() modelRef: FirstNameModel;
  @Input() requiredField: boolean;
  @Input() redStar: boolean;
  @Input() autoFocus: boolean = false;
  @Input() id: string;
  @Output() focusEvent = new EventEmitter<NgModel>();
  @Output() focusoutEvent = new EventEmitter<NgModel>();
  @ViewChild("firstName", { static: true }) firstName: NgModel;

  firstNameValidation = FIRST_NAME_VALIDATION;

  constructor(private titleCasePipe: TitleCasePipe) {}

  public onFocus() {
    this.focusEvent.next(this.firstName);
  }

  public onFocusOut() {
    this.focusoutEvent.next(this.firstName);
  }

  public setFirstName(value: string) {
    this.modelRef.firstName = this.titleCasePipe.transform(value);
  }

  public onPaste($event) {
    this.modelRef.firstName = this.titleCasePipe.transform($event.target.value);
  }
}
